// Events
export const SIZOTSA_APPLICATION_POLICY_REQUEST =
  "sizotsaFuneralCover/policyRequest/";

export const SUBMIT_POLICY_REQUEST=SIZOTSA_APPLICATION_POLICY_REQUEST+'submitPolicy'
export const submitPolicy = () => ({  
  type: SUBMIT_POLICY_REQUEST,
}); 

// get quotation
export const GET_QUOTE_REQUEST=SIZOTSA_APPLICATION_POLICY_REQUEST+'getQuote'
export const getQuoteRequest = () => ({  
  type: GET_QUOTE_REQUEST,
}); 


// send leads mail to business team
export const SEND_LEADS_EMAIL=SIZOTSA_APPLICATION_POLICY_REQUEST+'sendLeadsMail'
export const sendLeadsMail = () => ({  
  type: SEND_LEADS_EMAIL,
}); 

export const SEND_UPLOAD_DOCUMENTS=SIZOTSA_APPLICATION_POLICY_REQUEST+'uploadDocuments'

 export const uploadDocumentsRequest=()=>({
type:SEND_UPLOAD_DOCUMENTS,
})